const WORKER_URL = 'https://td-auth.josip-zuzic.workers.dev'

export class AuthManager {
  constructor() {
    this.token = localStorage.getItem('td_token') ?? null
    this.user  = null
  }

  // Returns true if token is valid, populates this.user
  async validate() {
    if (!this.token) return false
    try {
      const res  = await fetch(`${WORKER_URL}/auth/validate`, {
        headers: { Authorization: `Bearer ${this.token}` }
      })
      const data = await res.json()
      if (data.valid) {
        this.user = data.user
        return true
      }
    } catch {}
    this._clearSession()
    return false
  }

  async login(username, password) {
    const res  = await fetch(`${WORKER_URL}/auth/login`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ username, password })
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.error ?? 'Login failed')
    this._storeSession(data)
    return data.user
  }

  async register(username, password) {
    const res  = await fetch(`${WORKER_URL}/auth/register`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ username, password })
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.error ?? 'Registration failed')
    this._storeSession(data)
    return data.user
  }

  async loadData() {
    const res  = await fetch(`${WORKER_URL}/data/load`, {
      headers: { Authorization: `Bearer ${this.token}` }
    })
    if (!res.ok) throw new Error('Failed to load data')
    const { data } = await res.json()
    return data
  }

  async saveData(data) {
    const res = await fetch(`${WORKER_URL}/data/save`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:  `Bearer ${this.token}`
      },
      body: JSON.stringify({ data })
    })
    if (!res.ok) throw new Error('Failed to save data')
  }

  logout() { this._clearSession() }

  get isLoggedIn() { return !!this.token && !!this.user }

  _storeSession({ token, user }) {
    this.token = token
    this.user  = user
    localStorage.setItem('td_token', token)
  }

  _clearSession() {
    this.token = null
    this.user  = null
    localStorage.removeItem('td_token')
  }
}